import { Link } from "react-router-dom";
import { categories } from "@/mocks/topics";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-eye-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">天涯吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-500">
              聚焦热议焦点与舆论风向变化，实时追踪话题升温动态，汇总网友评论观点，帮你捕捉讨论热度走势，看懂舆论如何发酵与转向。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-800">观察栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {categories
                .filter((c) => c.slug !== "all")
                .slice(0, 5)
                .map((c) => (
                  <li key={c.slug}>
                    <Link
                      to={`/topics?cat=${c.slug}`}
                      className="text-sm text-foreground-500 transition-colors hover:text-primary-600"
                    >
                      {c.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-800">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600">首页</Link>
              </li>
              <li>
                <Link to="/topics" className="text-sm text-foreground-500 hover:text-primary-600">热议焦点</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600">关于我们</Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground-500 hover:text-primary-600">常见问题</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-800">联系我们</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-500">
              有话题线索或合作意向？
              <br />
              欢迎来信：editor@tianya-chigua.example
            </p>
            <div className="mt-4 flex items-center gap-2 text-foreground-500">
              <a href="https://weibo.com" aria-label="微博" rel="nofollow" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 bg-white text-sm hover:text-primary-600">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a href="https://x.com" aria-label="推特" rel="nofollow" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 bg-white text-sm hover:text-primary-600">
                <i className="ri-twitter-x-line" aria-hidden="true"></i>
              </a>
              <a href="mailto:editor@tianya-chigua.example" aria-label="邮件" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 bg-white text-sm hover:text-primary-600">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-50">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-400 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 天涯吃瓜 · 热议焦点与舆论风向观察站</p>
          <p className="flex flex-wrap items-center gap-x-2">
            <span>内容仅供参考，观点来自网络公开讨论归纳</span>
            <span className="hidden sm:inline">·</span>
            <a href="/sitemap.xml" className="hover:text-primary-600">网站地图</a>
          </p>
        </div>
      </div>
    </footer>
  );
}